import ContactExpert from "@modules/Layout/components/ContactExpert";
import React, { memo } from "react";

import BuildFlag from "@modules/Layout/components/BuildFlag";
import Cover from "@modules/Layout/components/Cover";
import IndustryLeader from "@modules/Layout/components/IndustryLeader";
import Content from "./Content";
import { ContentPage } from "@types/common";

interface Props {
  data: ContentPage;
}

const CompanyHistory: React.FC<Props> = ({ data }) => {
  return (
    <>
      <Cover banner={data?.banner} />
      <Content content={data.content} />
      <IndustryLeader />
      <BuildFlag />
      <ContactExpert />
    </>
  );
};

export default memo(CompanyHistory);
